export enum SheetIds {
  MULTI_SELECT = "multi-select",
  SINGLE_SELECT = "single-select",
  LEGAL = "legal",
  CHILDREN_SELECT = "children-select",
  TIME_SLOTS_SELECT = "time-slots-select",
  LOCATION = "location",
  LESSON = "lesson",
  PARENT_LESSON = "parent-lesson",
  ASSIGN_TIME_SLOT = "assign-time-slot",
  TUTOR_LESSON = "tutor-lesson",
  ADDITIONAL_LEARNING = "additional-learning",
  REFERENCE_INFO = "reference-info",
  DOWNLOAD_STUDY_MATERIAL_SHEET = 'download-study-material',
  LESSON_PRICE_LIST = "lesson-price-list",
  PARENT_CONNECT = "parent-connect",
  BUFFER_TIME_CONFLICT = "buffer-time-conflict",
  TIMEZONE_SEARCH = "timezone-search",
}
